import React from 'react';
import { propExistsAndNonEmpty } from '../../../util/utils';
import tagular from '../../../util/tagular';

const FilterItems = (props) => {
    const { filterGroup, selectedFilters, site } = props;
    let allFilters = filterGroup.filters;
    const maxSelection = filterGroup.maxSelection;

    let items;
    if (propExistsAndNonEmpty(allFilters)) {
        allFilters = allFilters.filter(filter => !filter.tag.includes('None of these'));

        items = allFilters.map((filter, idx) => {
            return (
                <label key={idx} className={`filter-checkbox ${site}`}>
                    {filter.resultDisplay}
                    <input type="checkbox" className='checkbox'
                        id={idx}
                        value={filter.tag}
                        name={filter.tag}
                        onChange={(event) => handleChange(event, maxSelection, props)}
                        checked={determineCheckedState(filter.tag, selectedFilters)}
                    />
                    <span className={`checkmark ${site}`}></span>
                </label>
            )
        });
    }

    return (
        <div className='filters-checkboxes'>
            {items}
        </div>
    );
};

const determineCheckedState = function (currentFilter, selectedFilters) {
    if (selectedFilters.includes(currentFilter)) {
        return true;
    } else {
        return false;
    }
}

const handleChange = function (event, maxSelection, props) {
    const { receiveFilter, removeFilter, assessmentName } = props;
    const allFilters = props.allFilters ? props.allFilters : [];
    const selectedState = event.target.checked;
    const selectedFilter = event.target.value;

    if (selectedState) {
        if (maxSelection == 1) {
            receiveFilter(selectedFilter);
            
            allFilters.forEach(filter => {
                if (filter.tag !== selectedFilter) {
                    removeFilter(filter.tag);
                }
            });
        } else {
            receiveFilter(selectedFilter);
        }

        tagular.sendElementClickedEvent(event, {
            assessmentName,
            action: 'FILTER'
        })

    } else {
        removeFilter(selectedFilter);
    }
};

export default FilterItems;